// extracted by mini-css-extract-plugin
export var actionButton = "_7o-1";
export var actionButtons = "_7o-2";
export var actions = "_7o-0";
export var aiUnread = "_7o-10";
export var alignCenter = "_7o-h";
export var backWrapper = "_7o-3";
export var cellContainer = "_7o-4";
export var checkboxContainer = "_7o-5";
export var contentContainer = "_7o-6";
export var contentHeader = "_7o-8";
export var conversationsTableWrapper = "_7o-s";
export var draftReplyBadgeContainer = "_7o-m";
export var dropdownItem = "_7o-b";
export var dropdownItemsContainer = "_7o-a";
export var dropdownTitle = "_7o-c";
export var errorIcon = "_7o-7";
export var filter = "_7o-d";
export var gray = "_7o-i";
export var headerActionButtons = "_7o-e";
export var headerCheckboxContainer = "_7o-f";
export var icon = "_7o-j";
export var menuContainer = "_7o-k";
export var noMoreTicketsIcon = "_7o-12";
export var noMoreTicketsSubText = "_7o-13";
export var oneLine = "_7o-l";
export var optionsButton = "_7o-n";
export var plus = "_7o-o";
export var portalButtonsWrapper = "_7o-g";
export var red = "_7o-p";
export var scrolledTop = "_7o-9";
export var search = "_7o-q";
export var selectedConversationsCount = "_7o-r";
export var spinner = "_7o-t";
export var strong = "_7o-u";
export var summaryCell = "_7o-v";
export var tableContainer = "_7o-11";
export var tagContainer = "_7o-w";
export var threeDots = "_7o-x";
export var twoLines = "_7o-y";
export var unread = "_7o-z";